<template>
  <div class="invite-tab-panel">
    <div class="invite-search">
      <input v-model="hostId" :placeholder="$t('lang.Invite.k055')" />
      <div class="search-divider"></div>
      <div class="search-btn" @click="handleSearch">{{ $t('lang.BaseModule.k052') }}</div>
    </div>

    <div class="time-switch-tab">
      <div class="time-tab" :class="{ 'active-tab': inviteTabIndex == 0 }" @click="handelInviteTab(0)">{{ $t('lang.BaseModule.k006') }}</div>
      <div class="time-tab" :class="{ 'active-tab': inviteTabIndex == 1 }" @click="handelInviteTab(1)">{{ $t('lang.Invite.k105') }}</div>
      <div class="time-tab" :class="{ 'active-tab': inviteTabIndex == 2 }" @click="handelInviteTab(2)">{{ $t('lang.Invite.k106') }}</div>
    </div>

    <div class="amount-block">
      <div class="amount-item">
        <div class="amount-count">{{ totalHostess }}</div>
        <div class="amount-title-row">
          <span class="amount-title">{{ $t('lang.Invite.k008') }}</span>
        </div>
      </div>
      <div class="amount-item">
        <div class="amount-count">
          <img :src="getMatchImg('beans')" alt="" />
          <span>{{ thousandthDigit(inviteBonus) }}</span>
        </div>
        <div class="amount-title-row">
          <span class="amount-title">{{ $t('lang.Invite.k099') }}</span>
        </div>
      </div>
    </div>

    <div class="host-list">
      <div class="host-card" v-for="(item, index) in hosts" :key="index">
        <div class="host-card-header">
          <van-image class="avatar-left" :src="item.avatar | imgPath" fit="cover" round lazy-load />
          <div class="host-card-main">
            <div class="host-name-row">
              <span class="host-name">{{ item.nickname }}</span>
              <img class="country-icon" :src="item.locationFlag | imgPath" alt="" />
            </div>
            <div class="host-id-row" @click="handleCopyId(item)">
              <span>ID：{{ item.presentId }}</span>
              <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
            </div>
          </div>
          <div class="host-card-side">
            <span class="host-date">{{ handleMoment(item.createTime, 'DD MMM YYYY') }}</span>
            <div v-if="!!item.hasContact" class="info-card-btn" @click="handleViewProfile(item)">
              <img src="@/assets/packageAssets/views/P2_Page/Invite/default/info.webp" alt="" />
            </div>
          </div>
        </div>

        <div class="status-item" v-if="item.ifShowTaskProcess">
          <div class="status-line">
            <div class="status-line-fill" :style="{ width: getStatusLineProgress(item) }"></div>
          </div>
          <!-- verified -->
          <div class="status-card" :style="`justify-content: ${item.activityTaskState ? 'space-around' : 'space-between'}`">
            <div>
              <div class="status-step">
                <div class="step-icon icon-step1" @click.stop="showTips($event, item.verifiedTip)"></div>

                <!-- 状态图标 -->
                <div v-if="item.verifyState === 1" class="status-icon icon-done"></div>
                <div v-if="item.verifyState === 2" class="status-icon icon-checking"></div>
                <div v-if="item.verifyState === 3" class="status-icon icon-fail"></div>
              </div>
            </div>

            <!-- common -->
            <!-- 第三步activity存在 -->
            <div v-if="item.activityTaskState" class="status-step">
              <div class="step-icon icon-step2" @click.stop="showTips($event, item.commonTaskTip)"></div>

              <!-- 状态图标 -->
              <template v-if="item.commonTaskState === 1">
                <div class="status-icon icon-done"></div>
                <span class="beans-num highline">
                  <img :src="getMatchImg('beans')" />
                  {{ item.commRewardBeans }}
                </span>
              </template>

              <template v-if="item.commonTaskState === 2">
                <div class="status-icon icon-checking"></div>
                <span class="beans-num">
                  <img :src="getMatchImg('beans-off')" />
                  {{ item.commRewardBeans }}
                </span>
              </template>

              <template v-if="item.commonTaskState === 3">
                <div class="status-icon icon-fail"></div>
                <span class="beans-num underline">
                  <img :src="getMatchImg('beans-off')" />
                  {{ item.commRewardBeans }}
                </span>
              </template>
            </div>

            <!-- 第三步activity不存在 -->
            <div v-else>
              <div class="status-step">
                <div class="step-icon icon-step2" @click.stop="showTips($event, item.commonTaskTip)"></div>

                <!-- 状态图标 -->
                <template v-if="item.commonTaskState === 1">
                  <div class="status-icon icon-done"></div>
                  <span class="beans-num highline">
                    <img :src="getMatchImg('beans')" />
                    {{ item.commRewardBeans }}
                  </span>
                </template>

                <template v-if="item.commonTaskState === 2">
                  <div class="status-icon icon-checking"></div>
                  <span class="beans-num">
                    <img :src="getMatchImg('beans-off')" />
                    {{ item.commRewardBeans }}
                  </span>
                </template>

                <template v-if="item.commonTaskState === 3">
                  <div class="status-icon icon-fail"></div>
                  <span class="beans-num underline">
                    <img :src="getMatchImg('beans-off')" />
                    {{ item.commRewardBeans }}
                  </span>
                </template>
              </div>
            </div>

            <!-- activity -->
            <div v-if="item.activityTaskState">
              <div class="status-step">
                <div class="step-icon" @click.stop="showTips($event, item.activityTaskTip)">
                  <img :src="getMatchImg('beans')" />
                </div>

                <!-- 状态图标 -->
                <div v-if="item.activityTaskState === 1" class="status-icon icon-done"></div>
                <div v-if="item.activityTaskState === 2" class="status-icon icon-checking"></div>
                <div v-if="item.activityTaskState === 3" class="status-icon icon-fail"></div>

                <!-- 文案 -->
                <template v-if="item.activityTaskState === 1">
                  <span class="beans-num highline">
                    <img :src="getMatchImg('beans')" />
                    {{ item.activityRewardBeans }}
                  </span>
                </template>

                <template v-if="item.activityTaskState === 2">
                  <span class="beans-num">
                    <img :src="getMatchImg('beans-off')" />
                    {{ item.activityRewardBeans }}
                  </span>
                </template>

                <template v-if="item.activityTaskState === 3">
                  <span class="beans-num underline">
                    <img :src="getMatchImg('beans-off')" />
                    {{ item.activityRewardBeans }}
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && !hosts.length" class="host-list-empty"></div>
    </div>

    <div v-if="loading" class="is-loading">
      <van-loading size="24px" />
    </div>

    <div v-if="finished" class="no-more">{{ $t('lang.Invite.k101') }}</div>

    <!-- 搜索弹框组件 -->
    <InviteSearch :showDia="showSearchDia" :hostDate="searchHostData" />

    <ConfirmAuto
      :showDia="removeConfirmAutoDia"
      :title="removeTitle"
      :content="removeContent"
      :leftBtnText="leftBtnText"
      :rightBtnText="rightBtnText"
      @leftBtn="removeLeftBtn"
      @rightBtn="removeRightBtn"
    />

    <TipOnclick v-if="tipsInfo.show" :position="tipsInfo.position" :text="tipsInfo.text" :direction="tipsInfo.direction" />

    <!-- View Contact Popup -->
    <van-popup v-model="showViewContact" round :style="{ background: 'transparent' }" :close-on-click-overlay="true">
      <div class="view-contact-container">
        <div class="view-contact-popup">
          <div class="view-contact-header">
            <div class="view-avatar-wrap">
              <img v-if="viewContact.avatar" class="view-avatar-img" :src="viewContact.avatar | imgPath" alt="" />
              <div v-else class="view-avatar-placeholder"></div>
            </div>
            <div class="view-user-name">
              <span class="name-text">{{ viewContact.nickname }}</span>
              <img class="flag" :src="viewContact.locationFlagRound | imgPath" alt="" />
            </div>
          </div>

          <div class="view-contact-list">
            <div class="view-contact-row">
              <span class="view-label">{{ $t('lang.BaseModule.k064') }}</span>
              <div class="view-value">
                <span :class="{ 'is-empty': !viewContact.whatsapp }">{{ viewContact.whatsapp || $t('lang.Invite.k054') }}</span>
                <img
                  class="copy-icon"
                  :class="{ 'is-disabled': !viewContact.whatsapp }"
                  src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp"
                  alt=""
                  @click="viewContact.whatsapp && handleCopy(viewContact.whatsapp, $t('lang.BaseModule.k070'))"
                />
              </div>
            </div>

            <div class="view-contact-row">
              <span class="view-label">{{ $t('lang.BaseModule.k058') }}</span>
              <div class="view-value">
                <span :class="{ 'is-empty': !viewContact.telegram }">{{ viewContact.telegram || $t('lang.Invite.k054') }}</span>
                <img
                  class="copy-icon"
                  :class="{ 'is-disabled': !viewContact.telegram }"
                  src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp"
                  alt=""
                  @click="viewContact.telegram && handleCopy(viewContact.telegram, $t('lang.BaseModule.k070'))"
                />
              </div>
            </div>
          </div>

          <div class="popup-btn" @click="showViewContact = false">{{ $t('lang.BaseModule.k073') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { apiSearchAgent, apiDeleteAgent, getContactInfoApi } from '@/api/invite'
import { apiFetchMyInvite } from '@/api/imee'

import eventBus from '@/utils/eventbus'

import InviteSearch from '@/views/P2_Page/Invite/components/InviteSearch.vue'
import CConfirmAuto from '@/components/CConfirmAuto'
import TipOnclick from '@/components/TipOnclick/index.vue'

export default {
  name: 'InviteTab',
  components: { InviteSearch, ConfirmAuto: CConfirmAuto, TipOnclick },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      },
    },
  },
  data() {
    return {
      inviteTabIndex: 0,
      listQuery: {
        limit: 5,
        offset: 0,
      },
      loading: false,
      finished: false,
      hosts: [],
      totalHostess: 0,
      inviteBonus: 0,
      hostId: '',
      showSearchDia: false,
      searchHostData: null,
      removeConfirmAutoDia: false,
      removeTitle: this.$t('lang.Invite.k034'),
      removeContent1: this.$t('lang.Invite.k032'),
      removeContent2: this.$t('lang.Invite.k033'),
      leftBtnText: this.$t('lang.BaseModule.k049'),
      rightBtnText: this.$t('lang.BaseModule.k067'),
      tipsInfo: {
        show: false,
        position: {
          left: '',
          top: '',
        },
        text: '',
        direction: '',
      },
      showViewContact: false,
      viewContact: {},
    }
  },
  computed: {
    removeContent() {
      const getMatchColor = {
        default: '#a338fc',
        kiko: '#ff8a33',
      }

      const colorVal = getMatchColor[this.packageName] || 'default'

      return `${this.removeContent1}<i style="color:${colorVal}">ID${this.hostId} </i>${this.removeContent2}`
    },
  },
  methods: {
    getNativeScroll() {
      let parent = this.$parent
      while (parent) {
        if (parent.nativeScroll) {
          return parent.nativeScroll
        }
        parent = parent.$parent
      }
      return null
    },
    isTaskDone(state) {
      return state === 1
    },
    getStatusLineProgress(item) {
      const seg1Done = this.isTaskDone(item.verifyState) && this.isTaskDone(item.commonTaskState)

      if (!item.activityTaskState) {
        return seg1Done ? '100%' : '0%'
      }

      const seg2Done = this.isTaskDone(item.commonTaskState) && this.isTaskDone(item.activityTaskState)

      if (seg1Done && seg2Done) {
        return '100%'
      }
      if (seg1Done) {
        return '50%'
      }
      return '0%'
    },
    handleCopyId(item) {
      try {
        window.ta && window.ta.track('agent_center', { Action: 'Click', APosition: 'button', AValue: 'copy' })
      } catch (err) {
        console.log('try catch', err)
      }
      this.handleCopy(item.presentId, this.$t('lang.BaseModule.k070'))
    },
    fetchMyInvite(val) {
      if (this.loading) {
        return
      }
      this.loading = true
      const params = {
        timeType: val,
        ...this.listQuery,
      }
      apiFetchMyInvite(params)
        .then((res) => {
          if (res && !res.error) {
            if (params.timeType === this.inviteTabIndex) {
              this.totalHostess = res.total || 0
              this.inviteBonus = res.inviteBonusBeans || 0
              this.hosts = this.hosts.concat(res.hosts || [])
              this.listQuery.offset = this.hosts.length

              this.loading = false
              this.finished = (res.hosts || []).length < this.listQuery.limit

              if (!this.finished) {
                const nativeScroll = this.getNativeScroll()
                nativeScroll && nativeScroll.finishPullUp()
              }

              this.$nextTick(() => {
                const nativeScroll = this.getNativeScroll()
                nativeScroll && nativeScroll.refresh()
              })
            } else {
              this.loading = false
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handelInviteTab(arg) {
      this.inviteTabIndex = arg
      this.hosts = []
      this.loading = false
      this.finished = false
      this.listQuery.limit = 10
      this.listQuery.offset = 0
      this.fetchMyInvite(this.inviteTabIndex)
    },
    getHosts() {
      this.fetchMyInvite(this.inviteTabIndex)
    },
    handleSearch() {
      if (this.hostId) {
        apiSearchAgent(this.hostId).then((res) => {
          if (res && res.uid) {
            this.searchHostData = res
            this.showSearchDia = true
          }
        })
      }
    },
    closeSearchDia() {
      this.showSearchDia = false
    },
    removeBtn() {
      this.showSearchDia = false
      this.removeConfirmAutoDia = true
    },
    removeLeftBtn() {
      if (this.hostId) {
        apiDeleteAgent(this.hostId).then((res) => {
          if (res) {
            this.removeConfirmAutoDia = false
            this.hosts = []
            this.listQuery.limit = 10
            this.listQuery.offset = 0
            this.hostId = null
            this.fetchMyInvite(this.inviteTabIndex)
          }
        })
      }
    },
    removeRightBtn() {
      this.removeConfirmAutoDia = false
    },
    scrollEvent(arg) {
      if (arg.type === 'arriveBottom') {
        this.fetchMyInvite(this.inviteTabIndex)
        return
      }
      if (arg.type === 'scroll') {
        this.hideTips()
      }
    },
    showTips(e, text) {
      const screenW = document.body.clientWidth
      const leftLimit = screenW / 3
      const rightLimit = leftLimit * 2

      let left = e.x
      const top = e.y - 14
      let dir = 'top'
      if (e.x < leftLimit) {
        dir = 'top-left'
        left = left - 14
      }
      if (e.x > leftLimit && e.x < rightLimit) {
        dir = 'top'
      }
      if (e.x > rightLimit) {
        dir = 'top-right'
        left = left + 14
      }

      this.tipsInfo.position.left = `${left}px`
      this.tipsInfo.position.top = `${top}px`
      this.tipsInfo.text = text
      this.tipsInfo.direction = dir
      this.tipsInfo.show = true
    },
    hideTips() {
      this.tipsInfo.show = false
      this.tipsInfo.position.left = ''
      this.tipsInfo.position.top = ''
      this.tipsInfo.text = ''
      this.tipsInfo.direction = ''
    },
    async handleViewProfile(item) {
      try {
        const resData = await getContactInfoApi({
          toUid: item.uid,
          scene: 0,
        })
        if (resData && !resData.error) {
          this.viewContact = resData
          this.showViewContact = true
        }
      } catch (e) {}
    },
  },
  created() {
    eventBus.$on('InviteScroll', this.scrollEvent)
    this.handelInviteTab(0)
    document.body.addEventListener('click', this.hideTips)
  },
  beforeDestroy() {
    eventBus.$off('InviteScroll', this.scrollEvent)
    document.body.removeEventListener('click', this.hideTips)
  },
}
</script>

<style lang="scss" scoped>
.invite-tab-panel {
  .invite-search {
    margin-top: 12px;
    display: flex;
    align-items: center;
    width: 100%;
    background: #f6f6f5;
    border-radius: 8px;
    overflow: hidden;

    input {
      flex: 1;
      min-width: 0;
      height: 44px;
      padding: 0 12px;
      border: none;
      background: transparent;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #333333;

      &::placeholder {
        color: #cccccc;
      }
    }

    .search-divider {
      width: 1px;
      height: 16px;
      background: #d9d9d9;
      flex-shrink: 0;
    }

    .search-btn {
      padding: 12px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-body-20);
      color: #cccccc;
      white-space: nowrap;
    }
  }

  .time-switch-tab {
    padding: 12px 0 8px 0;
    display: flex;
    align-items: center;
    overflow-x: auto;

    .time-tab {
      padding: 8px 16px;
      font-family: var(--string-font);
      font-weight: var(--fw-400);
      font-size: var(--fs-14);
      line-height: var(--lh-title-20);
      color: #b2b2b2;
      white-space: nowrap;
      text-align: center;

      &.active-tab {
        background: #f1e8d9;
        border-radius: 36px;
        color: #925e0d;
      }
    }
  }

  .amount-block {
    display: flex;
    align-items: stretch;
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 12px 14px;
    border-radius: 12px;
    box-sizing: border-box;

    .amount-item {
      flex: 1;
      min-width: 0;
      padding: 0;

      .amount-count {
        display: flex;
        align-items: center;
        font-family: var(--number-font);
        font-weight: var(--fw-600);
        font-size: var(--fs-20);
        line-height: var(--lh-title-28);
        color: #333333;

        span {
          margin-inline-start: 2px;
        }

        img {
          width: 20px;
          height: 20px;
        }
      }

      .amount-title-row {
        display: flex;
        align-items: center;
        margin-top: 2px;
      }

      .amount-title {
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        line-height: var(--lh-body-18);
        color: #b2b2b2;
      }
    }
  }

  .host-list {
    padding-top: 8px;
    display: flex;
    flex-direction: column;

    .host-card {
      background: #f9f8f6;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 8px;

      .host-card-header {
        display: flex;
        align-items: flex-start;

        .avatar-left {
          width: 44px;
          height: 44px;
          flex-shrink: 0;
        }

        .host-card-main {
          margin-inline-start: 8px;
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;

          .host-name-row {
            display: flex;
            align-items: center;

            .country-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              border: 0.5px solid rgba(102, 102, 102, 0.1);
            }

            .host-name {
              font-family: var(--string-font);
              font-weight: var(--fw-400);
              font-size: var(--fs-16);
              line-height: var(--lh-title-20);
              color: #333333;
            }
          }

          .host-id-row {
            margin-top: 8px;
            display: flex;
            align-items: center;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-label-16);
            color: #b2b2b2;

            span {
              white-space: nowrap;
            }

            .copy-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
            }
          }
        }

        .host-card-side {
          margin-inline-start: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          align-self: stretch;
          flex-shrink: 0;

          .host-date {
            flex: 1;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-label-16);
            color: #b2b2b2;
            text-align: end;
          }

          .info-card-btn {
            display: flex;
            padding: 4px 8px;
            justify-content: center;
            align-items: center;
            border-radius: 18px;
            background: linear-gradient(273deg, #f6ddb9 0%, #f5efd9 100%), #fff;

            img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }

      .status-item {
        width: 100%;
        margin-top: 12px;
        padding-top: 12px;
        border-top: 1px solid #f5f2ee;
        background: transparent;
        position: relative;
        box-sizing: border-box;

        .status-card {
          display: flex;
          justify-content: space-around;
          position: relative;
          z-index: 1;
          padding-bottom: 0;

          > div:first-child .status-step {
            align-items: flex-start;
          }

          > div:last-child .status-step {
            align-items: flex-end;
          }
        }

        .status-line {
          width: calc(100% - 16px);
          height: 8px;
          background: #ebe5dd;
          border-radius: 8px;
          position: absolute;
          top: 20px;
          inset-inline-start: 8px;
          transform: none;
          z-index: 0;
          overflow: hidden;

          .status-line-fill {
            height: 4px;
            margin-top: 2px;
            background: #e6a772;
            border-radius: 8px;
            width: 0;
          }
        }

        .status-step {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;

          .status-icon,
          .beans-num {
            margin-top: 4px;
          }

          .step-icon {
            display: flex;
            width: 24px;
            height: 24px;
            background-color: #ebe5dd;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            background-size: 20px 20px;
            background-position: center;
            background-repeat: no-repeat;
            flex-shrink: 0;

            img {
              width: 20px;
              height: 20px;
            }

            &.icon-step1,
            &.icon-step2 {
              background-size: 100% 100%;
            }

            &.icon-step1 {
              background-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/status-icon-1.webp');
            }

            &.icon-step2 {
              background-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/status-icon-2.webp');
            }
          }

          .status-icon {
            width: 12px;
            height: 12px;
            margin: 4px 6px 0;
            display: block;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;

            &.icon-done {
              background-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/checked.webp');
            }

            &.icon-checking {
              background-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/wait.webp');
            }

            &.icon-fail {
              background-image: url('~@/assets/packageAssets/views/P2_Page/Invite/default/fail.webp');
            }
          }

          .beans-num {
            margin-top: 4px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-10);
            line-height: var(--lh-label-14);
            color: #666666;
            display: flex;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
              margin: 0 1px;
            }

            &.highline {
              color: #333333;
            }

            &.underline {
              color: #cccccc;
              text-decoration-line: line-through;
            }
          }
        }
      }
    }

    .host-list-empty {
      min-height: 120px;
      background: #fefefe;
      border-radius: 12px;
    }
  }

  .is-loading {
    padding-top: 10px;
    text-align: center;
  }

  .no-more {
    padding-top: 10px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .invite-tab-panel {
    .host-list {
      .host-card {
        .host-card-header {
          .host-card-side {
            .info-card-btn {
              background: linear-gradient(87deg, #f6ddb9 0%, #f5efd9 100%), #fff;
            }
          }
        }

        .status-item {
          .status-card {
            > div:first-child .status-step {
              align-items: flex-end;
            }

            > div:last-child .status-step {
              align-items: flex-start;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.view-contact-container {
  width: 343px;
  max-width: calc(100vw - 32px);
  box-sizing: border-box;

  .view-contact-popup {
    background: #fff;
    border-radius: 16px;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .view-contact-header {
      display: flex;
      flex-direction: column;
      align-items: center;

      .view-avatar-wrap {
        .view-avatar-placeholder,
        .view-avatar-img {
          width: 68px;
          height: 68px;
          border-radius: 50%;
          background-color: #d0cdd8;
          object-fit: cover;
        }
      }

      .view-user-name {
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        .flag {
          margin-inline-start: 2px;
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          object-fit: cover;
        }

        .name-text {
          max-width: 240px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-16);
          line-height: var(--lh-title-20);
          color: #333333;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }

    .view-contact-list {
      margin-top: 16px;
      width: 100%;
      display: flex;
      flex-direction: column;
      padding: 0;
      background: #f9f9f9;
      border-radius: 12px;
      box-sizing: border-box;

      .view-contact-row + .view-contact-row {
        margin-top: 8px;
      }

      .view-contact-row {
        width: 100%;
        min-height: 52px;
        display: flex;
        align-items: center;
        padding: 16px 12px;
        box-sizing: border-box;

        .view-value {
          margin-inline-start: 16px;
          flex-shrink: 0;
          display: flex;
          align-items: center;

          .copy-icon {
            margin-inline-start: 8px;
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            cursor: pointer;

            &.is-disabled {
              opacity: 0.4;
              cursor: default;
            }
          }

          span {
            max-width: 140px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-14);
            line-height: var(--lh-title-20);
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &.is-empty {
              color: #b2b2b2;
            }
          }
        }

        .view-label {
          flex: 1;
          min-width: 0;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #666666;
          text-align: start;
        }
      }
    }

    .popup-btn {
      margin-top: 16px;
      width: 100%;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 6px 24px;
      border-radius: 12px;
      background: #f8e5bd;
      font-family: var(--string-font);
      font-weight: var(--fw-500);
      font-size: var(--fs-16);
      line-height: var(--lh-title-20);
      color: #925e0d;
      white-space: nowrap;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .view-contact-container {
    .view-contact-popup {
      .view-contact-list {
        .view-contact-row {
          .view-value {
            flex-direction: row-reverse;
          }
        }
      }
    }
  }
}
</style>
